




























import Vue, { PropType } from 'vue'
import { MUTATIONS_ACTIONS, SettingParametersType, FormatType } from '@/types'

export default Vue.extend({
  props: {
    resource: {
      type: Array as PropType<FormatType[]>,
      default: () => []
    }
  },
  methods: {
    togglePopup (key: string, field?: FormatType) {
      if (field && field.type === 'color') return

      this.$store.commit(MUTATIONS_ACTIONS.TOGGLE_POPUP, [key, field])
    },
    onChange ([group, item, newValue]: [string, FormatType, string]) {
      const subKey = item.id
      const changeEvent: SettingParametersType = {
        group,
        oldItem: {
          key: item.id,
          value: ''
        },
        newItem: {
          key: subKey,
          value: newValue
        }
      }
      this.$store.commit(MUTATIONS_ACTIONS.SET_TAILWIND_CONFIG, changeEvent)
    }
  }
})
